import { useEffect } from "react";
export const useOverlayEvents = ({ closeOnIntent, isTouch, mode, clearClose, positionerRef, shouldCloseOnOutsideInteraction }) => {
    useEffect(() => {
        if (!positionerRef.current || isTouch || mode !== "tooltip") {
            return;
        }
        const positioner = positionerRef.current;
        // Keeps positioner open if hovered
        positioner.addEventListener("mouseenter", clearClose);
        positioner.addEventListener("mouseleave", closeOnIntent);
        return () => {
            positioner.removeEventListener("mouseenter", clearClose);
            positioner.removeEventListener("mouseleave", closeOnIntent);
        };
    });
    useEffect(() => {
        if (!shouldCloseOnOutsideInteraction) {
            return;
        }
        let closeTimeout;
        // Close popper when iframes on the page (like google maps) are clicked.
        // otherwise they get stuck open.
        const closeOnIframeClick = () => {
            closeOnIntent();
            closeTimeout = window.setTimeout(() => {
                if (document.activeElement?.tagName !== "IFRAME") {
                    clearClose();
                    closeTimeout = undefined;
                }
            });
        };
        window.addEventListener("blur", closeOnIframeClick);
        return () => {
            window.removeEventListener("blur", closeOnIframeClick);
            closeTimeout && clearClose();
        };
    }, [clearClose, closeOnIntent, shouldCloseOnOutsideInteraction]);
};
